var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8291 19.0788H13.5891C13.1791 19.0788 12.8391 18.7388 12.8391 18.3288C12.8391 17.9188 13.1791 17.5788 13.5891 17.5788H17.0791V14.0888C17.0791 13.6788 17.4191 13.3388 17.8291 13.3388C18.2391 13.3388 18.5791 13.6788 18.5791 14.0888V18.3288C18.5791 18.7488 18.2391 19.0788 17.8291 19.0788Z",
    fill: "#6C757D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8286 19.0788C17.6386 19.0788 17.4486 19.0088 17.2986 18.8588L11.6386 13.1988C11.3486 12.9088 11.3486 12.4288 11.6386 12.1388C11.9286 11.8488 12.4086 11.8488 12.6986 12.1388L18.3586 17.7988C18.6486 18.0888 18.6486 18.5688 18.3586 18.8588C18.2086 19.0088 18.0186 19.0788 17.8286 19.0788Z",
    fill: "#6C757D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.17137 0.92157H6.41138C6.82138 0.92157 7.16138 1.26157 7.16138 1.67157C7.16138 2.08157 6.82138 2.42157 6.41138 2.42157H2.92137V5.91156C2.92137 6.32156 2.58137 6.66156 2.17137 6.66156C1.76137 6.66156 1.42137 6.32156 1.42137 5.91156V1.67157C1.42137 1.25157 1.76137 0.92157 2.17137 0.92157Z",
    fill: "#6C757D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.17184 0.921538C2.36184 0.921538 2.55184 0.991539 2.70184 1.14154L8.36185 6.80153C8.65185 7.09153 8.65185 7.57154 8.36185 7.86154C8.07185 8.15154 7.59185 8.15154 7.30185 7.86154L1.64184 2.20154C1.35184 1.91154 1.35184 1.43154 1.64184 1.14154C1.79184 0.991539 1.98184 0.921538 2.17184 0.921538Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand-icon.a6b9bd3dfb6bb9b6163e9fb860617d92.svg";
export { ForwardRef as ReactComponent };